














































import { Component, Prop, Vue } from "vue-property-decorator";
import { IExcursionCategory as ICategory } from "@/@types/excursions/excursions";

import InputSearch from "@/components/app/search/input-search.vue";
import ButtonBack from "@/components/buttons/button-back.vue";
import ButtonHistory from "@/components/buttons/button-history.vue";
import ButtonCart from "@/components/buttons/button-cart.vue";
import StandartCategoryDd from "@/components/app/dropdowns/standart-category-dd.vue";

@Component({
  components: {
    ButtonBack,
    ButtonHistory,
    ButtonCart,
    StandartCategoryDd,
    InputSearch,
  },
})
export default class ExcursionsHeader extends Vue {
  @Prop({ type: Boolean, default: false }) excursionDeleted!: boolean;
  @Prop({ type: Number, default: 0 }) excLength!: number;
  @Prop({ type: String, default: "" }) activeCategory!: string;
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICategory>;

  get drop_rules(): boolean {
    const rule = this.excursionDeleted
      ? this.$getRight("forceDeleteExcursionById")
      : this.$getRight("moveExcursionToRecycler");
    return rule && this.excLength ? true : false;
  }
}
